// The  Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias .
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import app from '@/helpers/app'
import storage from '@/helpers/storage'
import okta from '@/helpers/okta'
// import authApi from '@/helpers/auth-api'
import { locale } from '@/i18n/locale.js';
// import tableExport from 'tableexport'

(async () => {
  Vue.config.productionTip = false
// Get Authorization detail
// okta.oktaIsSessionActive().then(function (res) {
//   var oktaActivationToken = router.match(document.location.href).query.activationToken
//   var selfRegToken = router.match(document.location.href).query.selfRegToken
//   var fromUserReg = router.match(document.location.href).query.fromUserReg
//   // var dashboardPos = document.location.href.toLowerCase().indexOf('dashboard')
//   var oktaResetPwdToken = router.match(document.location.href).query.resetPwdToken
//   // var tempToken = document.location.href.split('=')[1]
//   if (res || (oktaActivationToken !== null && oktaActivationToken !== undefined) || (oktaResetPwdToken !== null && oktaResetPwdToken !== undefined)) {
//     const urlAuth = app.getAuthenticationUserFromUrl(document.location.href);
//     const storedAuth = app.getAuthenticationUserFromStorage();
//     // const isActiveSession = okta.oktaIsSessionActive();
//     if (urlAuth) {
//       store.commit('setUser', urlAuth);
//     } else if (storedAuth) {
//       store.commit('setUser', storedAuth);
//     } else {
//       if (oktaActivationToken !== null && oktaActivationToken !== undefined) {
//         // router.push({name: 'UserRegistration', query: { activationToken: tempToken }});
//       } else if (selfRegToken !== null && selfRegToken !== undefined) {
//         // router.push({name: 'SelfRegistration', query: { selfRegToken: tempToken }});
//       } else if (oktaResetPwdToken !== null && oktaResetPwdToken !== undefined) {
//         // router.push({name: 'ResetPassword', query: { resetPwdToken: tempToken }});
//       } else if (fromUserReg !== null && fromUserReg !== undefined) {
//         // router.push({name: 'Login', query: { fromUserReg: tempToken }});
//       } else {
//         // router.push({ name: 'Login' });
//       }
//     }
//   } else if (document.location.href.toLowerCase().indexOf('login') === -1 &&
//   (document.location.href.toLowerCase().indexOf('userregistration') === -1) && // eslint-disable-line
//   (document.location.href.toLowerCase().indexOf('selfregistration') === -1) && // eslint-disable-line
//   !(document.location.href.toLowerCase().substr('resetpassword'.length * -1) === 'resetpassword') && // eslint-disable-line
//   !(document.location.href.toLowerCase().substr('unlockaccount'.length * -1) === 'unlockaccount')) { // eslint-disable-line
//     okta.oktaSignOut()
//   }
// });
  var isAuth = await Vue.prototype.$auth.isAuthenticated()
  console.log(isAuth)
  okta.checkTokens().then(function (resp) {
    console.log(resp)
  })
// Get Customer Tax ID
  if (store.state.user && store.state.user.email) {
    var authUserEmail = store.state.user.email;
    if (authUserEmail) {
      store.commit('setEmail', store.state.user.email);
      store.commit('setName', store.state.user.name);
      app.persistNameToStorage(store.state.user.name);
    }
  }

// set user language
  var userLang = 'en'
  if (navigator.userLanguage !== undefined) {
    userLang = navigator.browserLanguage.split('-')[0]
  } else {
    userLang = navigator.language.split('-')[0]
  }
  userLang = locale.lang_obj[userLang] !== undefined ? userLang : 'en'
  window.pref_lang = locale.lang_obj[userLang] !== undefined ? userLang : 'en'
  storage.set('pref_lang', userLang)

/* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
})()



// WEBPACK FOOTER //
// ./src/main.js